<script>
import { Scatter as chart } from 'vue-chartjs';
import bc from './base-chart';
export default { extends: chart, mixins: [bc]};
</script>
